<template>
    <CheckoutLayout
        :step="step"
    >
        <Heading
            :label="__('Summary')"
            :description="__('It\'s almost finished')"
            class="w-auto lg:my-8 my-4"
            size="xl"
        />

        <div class="grid grid-cols-1 xl:grid-cols-3 my-4">
            <table class="rounded-md xl:rounded-r-none overflow-hidden shadow-md col-span-2 h-full">
                <thead>
                    <tr
                        class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-700 border-gray-900">
                        <th class="px-4 py-3">{{__('Product')}}</th>
                        <th class="px-4 py-3">{{__('Variation')}}</th>
                        <th class="px-4 py-3">{{__('Font')}}</th>
                        <th class="px-4 py-3">{{__('Amount')}}</th>
                        <th class="px-4 py-3">{{__('Price')}}</th>
                        <th class="px-4 py-3">{{__('Total')}}</th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                    <tr
                        v-for="item in $page.props.cartitems"
                        :key="item"
                        class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400"
                    >
                        <td class="px-4 py-3">
                            <div class="flex items-center text-sm">
                                <div class="relative hidden w-8 h-8 mr-3 rounded-full md:block">
                                    <img class="object-cover w-full h-full rounded-full"
                                        :src="'/storage/products/'+item.product.images[0].link"
                                        alt="" loading="lazy">
                                    <div class="absolute inset-0 rounded-full shadow-inner" aria-hidden="true"></div>
                                </div>
                                <div>
                                    <p class="font-semibold" v-html="item.product.name"></p>
                                    <p class="text-xs text-gray-600 dark:text-gray-400" v-html="item.content"></p>
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3 text-sm">{{item.product_variation.name}}</td>
                        <td class="px-4 py-3 text-sm">{{item.font.name}}</td>
                        <td class="px-4 py-3 text-sm">
                            <span
                                class="px-2 py-1 font-bold"
                                v-html="getPieces(item)"
                            ></span>
                        </td>
                        <td class="px-4 py-3 text-sm">
                            <span
                                class="px-2 py-1 font-semibold leading-tight text-white bg-gray-500 rounded-full dark:bg-green-700 dark:text-green-100"
                            >
                            {{ pricePerItem(item) }}
                            </span>
                        </td>
                        <td class="px-4 py-3 text-sm">
                            <span
                                class="px-2 py-1 font-semibold leading-tight text-white bg-gray-500 rounded-full dark:bg-green-700 dark:text-green-100"
                            >
                            {{ getTotalPerProduct(item) }}
                            </span>
                        </td>
                    </tr>

                    <tr
                        class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400"
                    >
                        <td class="px-4 py-3">
                            <div class="flex items-center text-sm">
                                <div class="relative hidden w-8 h-8 mr-3 rounded-full md:block">
                                    <SvgIcon
                                        class="relative hidden w-8 h-8 mr-3 rounded-full md:block"
                                        :name="payments[selectedPayment].icon"
                                    />
                                    <div class="absolute inset-0 rounded-full shadow-inner" aria-hidden="true"></div>
                                </div>
                                <div>
                                    <p class="font-semibold" v-html="payments[selectedPayment].name"></p>
                                    <p class="text-xs text-gray-600 dark:text-gray-400" v-html="__('Payment')"></p>
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3 text-sm" colspan="5"></td>

                    </tr>

                    <tr
                        class="border-t-2 border-gray-400 bg-gray-700 dark:bg-gray-800 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400"
                    >
                        <td class="h-16 px-4 py-3 text-xl font-normal" colspan="6">
                            <div class="flex flex-row-reverse pr-4 text-gray-200">
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table class="rounded-md xl:rounded-l-none overflow-hidden shadow-md h-full lg:my-0 my-4">
                <thead>
                    <tr
                        class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-700 border-gray-900">
                        <th class="px-4 py-3" v-html="__('Address')" colspan="2"></th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                    <tr
                        v-for="(item, key) in address"
                        :key="key"
                        class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400"
                    >
                        <td class="px-4 py-2 text-sm uppercase font-bold">{{ __(key) }}</td>
                        <td class="px-4 py-3 xl:py-2 text-sm">{{ item }}</td>

                    </tr>
                    <tr
                        class="border-t-2 border-gray-400 bg-gray-700 dark:bg-gray-800 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400"
                    >
                        <td class="h-16 px-4 py-3 text-xl font-normal" colspan="6">
                            <div class="flex flex-row-reverse pr-4 text-gray-200">
                                <div>
                                    <span class="font-semibold">
                                        {{ getTotalPrice }}
                                    </span>
                                </div>
                            </div>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>

        <div
            class="flex justify-between lg:mt-0 mt-4 pt-4 lg:pt-0"
        >
            <InertiaLink
                class="px-4 text-white font-semibold py-1 rounded-md transition ease-in-out duration-300 bg-gray-600 hover:bg-gray-700"
                :href="route('checkout.payment')"
            >
                {{__('Back')}}
            </InertiaLink>
            <div
                class="px-4 text-white font-semibold py-1 rounded-md transition ease-in-out duration-300 bg-green-600 hover:bg-green-700 cursor-pointer"
                @click="pay()"
                :class="selectedPayment != null ? '':'opacity-50 pointer-events-none select-none'"
            >
                {{__('Pay')}}
            </div>
        </div>

        <div
            class="fixed h-screen w-screen top-0 left-0 flex items-center justify-center"
            style="background: rgba(0,0,0,0.5);"
            :class="paypal ? '':'hidden'"
            @click="paypal = false"
        >
            <div class="bg-white rounded-md p-8 shadow-md">
                <!-- <PayPal
                    @click.prevent
                ></PayPal> -->
            </div>
        </div>
    </CheckoutLayout>
</template>

<script>
import CheckoutLayout from '@/Layouts/Checkout';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';
import CustomSelect from 'UI/CustomSelect';
import InputLabel from 'UI/InputLabel';
import Steps from 'STEPS/Container';
import StepItem from 'STEPS/Item';
import moment from "moment";
// import PayPal from "COMP/PayPal";

import { useForm, usePage } from '@inertiajs/inertia-vue3'
import { ref } from '@vue/reactivity';
import Button from 'UI/Button';

import {
    getPrice,
    getPieces,
    getTotalPerProduct,
    pricePerItem,
} from 'helper';
import { computed } from '@vue/runtime-core';

export default {
    components: {
        CheckoutLayout,
        SvgIcon,
        Heading,
        CustomSelect,
        InputLabel,
        Button,
        Steps,
        StepItem,
        moment,
        // PayPal

    },
    props: {
        auth: Object,
        loggedin: Boolean,
        step: Number,
    },
    setup(props, {moment}) {
        const paypal = ref(false);
        const selectedShipping = ref(localStorage.getItem('shipment') ? localStorage.getItem('shipment'):null);
        const selectedPayment = ref(localStorage.getItem('payment') ? localStorage.getItem('payment'):null);
        const userData = ref(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')):null);
        const address = ref({
            'first_name': userData.value.first_name,
            'last_name': userData.value.last_name,
            'email': userData.value.email,
            'city': userData.value.city,
            'street': userData.value.street,
            'building': userData.value.building,
            'flat': userData.value.flat,
            'zip': userData.value.zip,
            'phone': userData.value.phone,
        },);
        const payments = ref([
            {
                'name': 'Przelewy24',
                'slug': 'p24',
                'icon': 'cash'
            },
            {
                'name': 'PayU',
                'slug': 'payu',
                'icon': 'cash'
            }
        ]);
        const user = props.loggedin ? props.auth.user : props.auth.guest;
        const cartSum = () => {
            let sum = 0;
            let items = usePage().props.value.cartitems;

            items.forEach(el => {
                sum += el.count * el.product.price;
            });

            return sum.toFixed(2);
        }

        const getTotalPrice = computed(() => {
            let sum = 0;
            let items = usePage().props.value.cartitems;

            items.forEach(el => {
                sum += getTotalPerProduct(el, false);
            });

            return getPrice(sum);
        })


        const pay_form = useForm({
            address: address.value,
            payment: payments.value[selectedPayment.value],
            user: props.loggedin ? props.auth.user : props.auth.guest,
            loggedin: props.loggedin
        });
        const pay = () => {
            pay_form.post(route('pay'))
            localStorage.removeItem('shipment');
            localStorage.removeItem('payment');

        }

        const formatDate = (date) => {
            // return moment(date).format('DD-MM-YYYY')
        }



        return {
            cartSum,
            user,
            selectedPayment,
            payments,
            selectedShipping,
            formatDate,
            userData,
            address,
            pay,
            pay_form,
            paypal,

            getTotalPrice,

            //helper
            getPrice,
            getPieces,
            getTotalPerProduct,
            pricePerItem
        }
    }
}
</script>
